import guards from './guards';

const BeginEnrolment = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/Begin.vue');
const EnrolmentRegister = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/Register.vue'
    );
const EnrolmentPersonal = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/Personal.vue'
    );
const EnrolmentHomeAddress = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/HomeAddress.vue'
    );
const EnrolmentSubscription = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/Subscription.vue'
    );
const EnrolmentBillingAddress = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/BillingAddress.vue'
    );
const EnrolmentConfirmation = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/Confirmation.vue'
    );
const EnrolmentPayment = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/CardPayment.vue'
    );
const EnrolmentFailedPayment = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/FailedPayment.vue'
    );
const EnrolmentSuccess = () =>
    import(
        /* webpackChunkName: "enrolment-bundle" */ '@S/Enrolment/Success.vue'
    );

export default [
    {
        path: '/enrolment/begin',
        name: 'begin-enrolment',
        component: BeginEnrolment,
        beforeEnter: guards.nonStepCheck
    },
    {
        path: '/enrolment/register',
        name: 'enrolment-register',
        component: EnrolmentRegister,
        beforeEnter: guards.enrolmentCheck
    },
    {
        path: '/enrolment/personal',
        name: 'enrolment-personal',
        component: EnrolmentPersonal,
        beforeEnter: guards.enrolmentCheck
    },
    {
        path: '/enrolment/home-address',
        name: 'enrolment-home-address',
        component: EnrolmentHomeAddress,
        beforeEnter: guards.enrolmentCheck
    },
    {
        path: '/enrolment/subscription',
        name: 'enrolment-subscription',
        component: EnrolmentSubscription,
        beforeEnter: guards.enrolmentCheck
    },
    {
        path: '/enrolment/billing-address',
        name: 'enrolment-billing-address',
        component: EnrolmentBillingAddress,
        beforeEnter: guards.enrolmentCheck
    },
    {
        path: '/enrolment/confirmation',
        name: 'enrolment-confirmation',
        component: EnrolmentConfirmation,
        beforeEnter: guards.enrolmentCheck
    },
    {
        path: '/enrolment/payment',
        name: 'enrolment-payment',
        component: EnrolmentPayment,
        beforeEnter: guards.enrolmentCheck
    },
    {
        path: '/enrolment/failed-payment',
        name: 'enrolment-failed-payment',
        component: EnrolmentFailedPayment
    },
    {
        path: '/enrolment/success',
        name: 'enrolment-success',
        component: EnrolmentSuccess,
        beforeEnter: guards.nonStepCheck
    }
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/enrollment.js